/**
 * Dos unidades distintas conviven en las metricas y confundirlas ya rompio el
 * dashboard: el resumen (`GET /metrics`) devuelve `deliveryRate` como
 * PORCENTAJE 0-100 (ver backend `api/metrics/schemas.ts`), mientras que la
 * tabla por canal se calcula en el front como PROPORCION (`delivered / sent`).
 * Pasar el porcentaje por el formateador de proporciones lo multiplicaba por
 * 100 otra vez: con 2 entregadas de 3 el dashboard mostraba `6667.0%`.
 *
 * Por eso hay dos funciones con nombres explicitos en vez de una sola: el tipo
 * `number` no distingue 0.6667 de 66.67, pero el nombre de la funcion si.
 */

/** Formatea un valor que YA es un porcentaje 0-100. */
export function formatPercent(percent: number): string {
  return `${percent.toFixed(1)}%`;
}

/** Formatea una proporcion 0-1 (p. ej. `delivered / sent`). */
export function formatRate(ratio: number): string {
  return formatPercent(ratio * 100);
}
